/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { type ComponentProps } from 'react';
import Picture from 'components/Picture/Picture';
import Title from '../ResponsiveTitle/ResponsiveTitle';
import { useImageHeight } from '../effects';
import useAnimation from './animations';
import './LargeIntro.scss';

const DEFAULT_IMAGE: ComponentProps<typeof Picture> = {};

interface LargeIntroProps {
  image?: ComponentProps<typeof Picture>;
  heading?: string;
  author?: string;
  photographer?: string;
}

/**
 * This is the LargeIntro component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function LargeIntro({
  heading = '',
  author,
  image = DEFAULT_IMAGE,
  photographer,
}: LargeIntroProps) {
  const imageRef = useImageHeight<HTMLDivElement>(200);
  const [ref] = useAnimation();

  function renderAuthor() {
    if (!author) return null;

    return <div className="author">{author}</div>;
  }

  function renderPhotographer() {
    if (!photographer) return null;

    return <div className="photo">{photographer}</div>;
  }

  return (
    <header ref={ref} className="header large-intro">
      <div ref={imageRef}>
        {renderAuthor()}
        <div className="image">
          <div>
            <Picture {...image} />
          </div>
        </div>
        {renderPhotographer()}
        <Title>{heading}</Title>
      </div>
    </header>
  );
}

export default LargeIntro;
